export const RESUME_DEFAULT_VALUES: any = {
	imageTitle: 'Profile Image',
	profilePicture: '',
	details: {
		firstName: '',
		lastName: '',
		countryCode: '',
		phoneNumber: '',
		email: '',
		website: '',
		designation: '',
		countryId: '',
		stateId: '',
		cityId: '',
		industryId: '',
		countryName: '',
		countryIsoCode: '',
		stateName: '',
		stateIsoCode: '',
		cityName: '',
		industryName: '',
		address: '',
	},
	detailTitle: 'Details',
	shortBioTitle: 'Short Bio',
	shortBio: '',
	experience: [
		{
			jobTitle: '',
			company: '',
			companyLogo: '',
			countryId: '',
			stateId: '',
			cityId: '',
			currentlyWorking: false,
			startDate: '',
			endDate: '',
			rolesDesc: '',
			countryName: '',
			countryIsoCode: '',
			stateName: '',
			stateIsoCode: '',
			cityName: '',
		},
	],
	experienceTitle: 'Experience',
	project: [
		{
			projectTitle: '',
			projectLink: '',
			projectDesc: '',
		},
	],
	projectTitle: 'Projects',
	education: [
		{
			degree: '',
			instituteName: '',
			instituteLogo: '',
			startDate: '',
			endDate: '',
			countryId: '',
			stateId: '',
			cityId: '',
			currentlyStudying: false,
			countryName: '',
			countryIsoCode: '',
			stateName: '',
			stateIsoCode: '',
			cityName: '',
		},
	],
	educationTitle: 'Education',
	tools: [],
	toolTitle: 'Tools',
	awards: [
		{
			title: '',
			year: '',
			description: '',
			logo: '',
		},
	],
	awardTitle: 'Awards',
	certification: [
		{
			title: '',
			year: '',
			description: '',
			image: '',
		},
	],
	certTitle: 'Certifications',
	langTitle: 'Languages',
	language: [],
	social: [],
	socialTitle: 'Social media handles',
	hobbies: [],
	hobbiesTitle: 'Hobbies',
	skillTitle: 'Skills',
	skills: [],
	templateFormOptions: {
		profileImage: true,
		details: true,
		shortBio: true,
		experience: false,
		experienceImage: true,
		experienceRoleAndResponsibilities: false,
		project: false,
		education: false,
		educationImage: true,
		skills: false,
		tools: false,
		language: false,
		social: false,
		certification: false,
		certificationsImage: true,
		hobbies: false,
		awards: false,
		awardImage: true,
	},
	manageTemplateFields: {
		details: true,
		shortBio: true,
		experience: false,
		project: false,
		education: false,
		skills: false,
		tools: false,
		awards: false,
		certification: false,
		language: false,
		social: false,
		hobbies: false,
	},
};

export const ARRAY_FIELDS = ['experience', 'project', 'education', 'certification', 'awards'];

export const SAVING_FIELDS: any = {
	detailTitle: ['imageTitle', 'profilePicture'],
	shortBioTitle: ['shortBioTitle', 'shortBio'],
	experienceTitle: ['experienceTitle', 'experience'],
	projectTitle: ['projectTitle', 'project'],
	educationTitle: ['educationTitle', 'education'],
	skillTitle: ['skillTitle', 'skills'],
	toolTitle: ['toolTitle', 'tools'],
	awardTitle: ['awardTitle', 'awards'],
	certTitle: ['certTitle', 'certification'],
	langTitle: ['langTitle', 'language'],
	socialTitle: ['socialTitle', 'social'],
	hobbiesTitle: ['hobbiesTitle', 'hobbies'],
};
